import React, {FC} from 'react';
import {Routes} from 'constants/index';
import {AllRegions} from 'utils/region';

import CardsSliderItem, {CardsSliderItemProps} from '..';

type LocationCardItemProps = Omit<CardsSliderItemProps, 'link'>;

// Search through our known regions for a matching title/name
const link = (title: string) => {
	const found = AllRegions.find((r) => r.name.includes(title));
	if (!found) {
		return Routes.booking;
	}
	return `${Routes.booking}?region=${found.key}`;
};

const LocationCardItem: FC<LocationCardItemProps> = (props) => (
	<CardsSliderItem
		{...props}
		link={link(props.title)}
	/>
);

export default LocationCardItem;
